import React from "react";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";
import ls from "local-storage";
import * as CONFIG from "./../pages/_config";
import ReactTooltip from "react-tooltip";
import { Helmet } from "react-helmet";
// import * as __html from './../pages/analytics'; //
import { setCSS } from "../pages/helper/helper";
import TagManager from 'react-gtm-module';

import Submenu from "./submenu";

const axios = require("axios");

class HeaderNav extends React.Component {
  redirectToAog = (event, menu) => {
    var UserToken = ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`)
      ? ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`).UserToken
      : "";

    var frmAOG = document.getElementById("frmAOG");
    if (frmAOG) {
      frmAOG.action = menu.menu_url;
      frmAOG.target = menu.menu_open_self == true ? "_self" : "_blank";
      frmAOG.submit();
    } else {
      window.location.href = menu.menu_url;
    }
    event.preventDefault();
    // return false; // cancel the actual link
  };

  render() {
    const { userdata, activeItem, cartlist } = this.props;

    if (CONFIG.DATA.WEEKLY_AD_TYPE === "IFRAME") {
      const weeklyAdsMenu = CONFIG.DATA?.MENU?.find(menu => menu?.menu_name?.toLowerCase() === "weekly ads");
      if (weeklyAdsMenu) {
        weeklyAdsMenu.submenu = [];
      }
    }

    return (
      <header
        className={
          "site-navbar js-sticky-header site-navbar-target" +
          (activeItem === false ? "" : "mobile-menu")
        }
        role="banner"
        style={{ position: "relative", backgroundColor: "white" }}
      >
        {userdata || true ? (
          <form id="frmAOG" method="post" target="_blank" className="aog-login">
            <input
              id="userid"
              name="userid"
              type="hidden"
              value={userdata?.UserId ?? ""}
            />
            <input
              id="usertoken"
              name="usertoken"
              type="hidden"
              value={userdata?.UserToken ?? ""}
            />
            <input
              id="member_number"
              name="member_number"
              type="hidden"
              value={userdata?.MemberNumber ?? ""}
            />
            <input
              id="from"
              name="from"
              type="hidden"
              value={CONFIG.DATA.DOMAIN_URL}
            />
          </form>
        ) : (
          ""
        )}

        <div
          className={
            CONFIG.DATA.THEME === 2 ? "container theme_2_menu" : "container"
          }
          style={
            CONFIG.DATA.RSA_SUBDOMAIN === "pigglywiggly"
              ? { marginTop: "10px" }
              : {}
          }
        >
          <div
            className="d-flex align-items-center"
            style={{
              height:
                CONFIG.DATA.RSA_SUBDOMAIN === "tresierrasbrothers"
                  ? "57px"
                  : CONFIG.DATA.RSA_SUBDOMAIN === "silverstreetmarket"
                  ? "12px"
                  : "",
            }}
          >
            <div className="site-logo navbar_logo">
              <Link to="/" className="d-block pt-0">
                <img
                  loading="lazy"
                  src={CONFIG.DATA.LOGO_HEADER}
                  alt={CONFIG.DATA.RSA_CLIENT_APP_NAME + " Logo"}
                  title={CONFIG.DATA.RSA_CLIENT_APP_NAME}
                  className={`img-fluid ${
                    CONFIG.DATA.RSA_SUBDOMAIN === "tresierrasbrothers" ||
                    "silverstreetmarket"
                      ? ""
                      : "img-logo"
                  }`}
                  style={{
                    maxWidth: `${
                      CONFIG.DATA.RSA_SUBDOMAIN === "brooksgrocery"
                        ? "450px"
                        : "200px"
                    }`,
                    maxHeight: `${
                      CONFIG.DATA.RSA_SUBDOMAIN === "tresierrasbrothers" ||
                      CONFIG.DATA.RSA_SUBDOMAIN === "silverstreetmarket"
                        ? "110px"
                        : "60px"
                    }`,
                    objectFit: `${
                      CONFIG.DATA.RSA_SUBDOMAIN === "silverstreetmarket"
                        ? "cover"
                        : ""
                    }`,

                    width: `${
                      CONFIG.DATA.RSA_SUBDOMAIN === "silverstreetmarket"
                        ? "100%"
                        : ""
                    }`,
                  }}
                />
              </Link>
            </div>

            {CONFIG.DATA.RSA_SUBDOMAIN !== "mcdanielpw" ? (
              <div
                className="mr-auto d-print-none btn-back-to-home-container"
                style={{
                  position: "relative",
                  right: "17px",
                  top: "6px",
                  width: "100%",
                }}
              >
                {CONFIG.DATA.ONLY_COUPONS &&
                CONFIG.DATA.BACKEND_HOST !== "lewisfood" &&
                CONFIG.DATA.BACKEND_HOST !== "haysmarketcoupons" ? (
                  <a
                    href={CONFIG.DATA.DOMAIN_URL}
                    rel="noopener noreferrer"
                    className="btn btn-theme btn-sm nav-link text-center d-print-none btn-back-to-home"
                    style={{
                      width: "180px",
                      fontWeight: "bold",
                      color: "#fff",
                      margin: "0px auto 11px auto",
                      backgroundColor:
                        CONFIG.DATA.RSA_SUBDOMAIN === "sfoodmarket"
                          ? "#075747"
                          : "#999999",
                      borderColor: "#999999",
                    }}
                  >
                    GO BACK
                  </a>
                ) : (
                  <nav
                    style={
                      {
                        /* bottom: userdata?'26px':'' */
                      }
                    }
                    className={
                      "site-navigation position-relative" +
                      (CONFIG.DATA.THEME === 2 ? " text-left " : " text-right ")
                    }
                    role="navigation"
                  >
                    <ul
                      id="sidebarmenus"
                      className={
                        "site-menu main-menu js-clone-nav mr-auto " +
                        (activeItem === false
                          ? "d-none"
                          : "navbar_sidebar_style") +
                        " d-lg-block font-weight-c " +
                        "nav navbar-nav megamenu"
                      }
                    >
                      {CONFIG.DATA.MENU.map((menu, index) => {
                        return menu.menu_visible ? (
                          <li
                            key={index}
                            className={
                              menu.submenu && menu.submenu.length > 0
                                ? "has-children"
                                : ""
                            }
                          >
                            {menu.aog_shop ? (
                              <a
                                onClick={(event) => {
                                  this.redirectToAog(event, menu);
                                }}
                                id={
                                  menu.menu_id && menu.menu_id.length > 0
                                    ? menu.menu_id
                                    : "menu__" + index
                                }
                                title={menu.menu_name}
                                href={menu.menu_url}
                                target={
                                  menu.menu_open_self ? "_self" : "_blank"
                                }
                                rel="noopener noreferrer"
                                className="nav-link text-left"
                              >
                                {menu.menu_name}
                              </a>
                            ) : menu.menu_link ? (
                              <a
                                title={menu.menu_name}
                                id={
                                  menu.menu_id && menu.menu_id.length > 0
                                    ? menu.menu_id
                                    : "menu__" + index
                                }
                                href={menu.menu_url}
                                target={
                                  menu.menu_open_self ? "_self" : "_blank"
                                }
                                rel="noopener noreferrer"
                                className="nav-link text-left"
                              >
                                {menu.menu_name}
                              </a>
                            ) : (
                              <Link
                                title={menu.menu_name}
                                to={
                                  menu.menu_has_page
                                    ? menu.menu_url.toLowerCase()
                                    : ""
                                }
                              >
                                {menu.menu_name}
                              </Link>
                            )}

                            {menu.submenu && menu.submenu.length > 0 ? (
                              <ul className="dropdown">
                                {CONFIG.DATA.BACKEND_HOST === "eldens" &&
                                menu.menu_name === "Departments" ? (
                                  <li key={`6`}>
                                    <Link
                                      title={`Floral`}
                                      to={`/departments/floral`}
                                      className="nav-link text-left"
                                    >
                                      {`Floral`}
                                    </Link>
                                  </li>
                                ) : (
                                  ""
                                )}

                                {CONFIG.DATA.BACKEND_HOST ===
                                  "countyfairfoodswatertown" &&
                                menu.menu_name === "Departments" ? (
                                  <Submenu />
                                ) : (
                                  ""
                                )}
                                {menu.submenu.map((submenu, index) => {
                                  return (
                                    <li key={index}>
                                      {submenu.submenu_link ? (
                                        //DATA.RSA_SUBDOMAIN
                                        <a
                                          title={menu.menu_name}
                                          href={submenu.submenu_url}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          className="nav-link text-left"
                                        >
                                          {submenu.submenu_name}
                                        </a>
                                      ) : (
                                        <Link
                                          title={menu.menu_name}
                                          to={submenu.submenu_url.toLowerCase()}
                                        >
                                          {submenu.submenu_name}
                                        </Link>
                                      )}
                                    </li>
                                  );
                                })}
                              </ul>
                            ) : (
                              ""
                            )}
                          </li>
                        ) : (
                          ""
                        );
                      })}
                    </ul>
                  </nav>
                )}
              </div>
            ) : (
              ""
            )}

            <div
              className={
                "cart-icon-count ml-auto d-print-none " +
                (activeItem === false ? "" : "navbar_cart")
              }
              style={CONFIG.DATA.THEME === 2 ? { marginBottom: "-15px" } : {}}
            >
              <Link
                to="/cart"
                data-tip
                data-for="tip-cart"
                className="notification"
                id="Notificationcount"
              >
                <img
                  loading="lazy"
                  title="View Cart"
                  alt="View Cart"
                  src="/assets/images/icons/shopingcarticons.png"
                />
                {<span className="badge">{cartlist}</span>}
              </Link>

              <ReactTooltip
                id="tip-cart"
                place="bottom"
                type="dark"
                effect="solid"
              >
                {cartlist > 0
                  ? "Click to view your shopping cart"
                  : "You have no items in your shopping cart"}
              </ReactTooltip>
            </div>
          </div>
        </div>

        {CONFIG.DATA.SEO ? (
          <Helmet>
            <meta
              name="viewport"
              content="width=device-width, initial-scale=1.0"
            ></meta>
            <meta property="type" content="website"></meta>
            <meta property="url" content={window.location.origin}></meta>
            {CONFIG.DATA.SEO.title ? (
              <meta name="title" content={CONFIG.DATA.SEO.title || ""}></meta>
            ) : (
              ""
            )}
            {CONFIG.DATA.SEO.description ? (
              <meta
                name="description"
                content={CONFIG.DATA.SEO.description || ""}
              ></meta>
            ) : (
              ""
            )}
            {CONFIG.DATA.SEO.keywords ? (
              <meta
                name="keywords"
                content={CONFIG.DATA.SEO.keywords || ""}
              ></meta>
            ) : (
              ""
            )}

            {/*Open Graph / Facebook*/}
            <meta property="og:type" content="website"></meta>
            <meta property="og:url" content={window.location.origin}></meta>
            {CONFIG.DATA.SEO.title ? (
              <meta
                name="og:title"
                content={CONFIG.DATA.SEO.title || ""}
              ></meta>
            ) : (
              ""
            )}
            {CONFIG.DATA.SEO.description ? (
              <meta
                name="og:description"
                content={CONFIG.DATA.SEO.description || ""}
              ></meta>
            ) : (
              ""
            )}
            {CONFIG.DATA.STORE_IMAGE ? (
              <meta
                property="og:image"
                content={window.location.origin + CONFIG.DATA.STORE_IMAGE || ""}
                itemProp="thumbnailUrl"
              ></meta>
            ) : (
              ""
            )}

            {/* Twitter*/}
            <meta property="og:type" content="website"></meta>
            <meta property="og:url" content={window.location.origin}></meta>
            {CONFIG.DATA.SEO.title ? (
              <meta
                name="twitter:title"
                content={CONFIG.DATA.SEO.title || ""}
              ></meta>
            ) : (
              ""
            )}
            {CONFIG.DATA.SEO.description ? (
              <meta
                name="twitter:description"
                content={CONFIG.DATA.SEO.description || ""}
              ></meta>
            ) : (
              ""
            )}
            {CONFIG.DATA.STORE_IMAGE ? (
              <meta
                property="twitter:image"
                content={window.location.origin + CONFIG.DATA.STORE_IMAGE || ""}
                itemProp="thumbnailUrl"
              ></meta>
            ) : (
              ""
            )}
          </Helmet>
        ) : (
          ""
        )}
      </header>
    );
  }
}

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      departments: [],
      stores: [],
      alldata: [],
      socialmediasettings: [],
      activeItem: false,
      cartlist: 0,
    };
  }

  componentDidMount() {
    setCSS();
    this.setJS();
    this.Departments();
    this.Stores();
    this.Alldata();
    this.Notification();
    this.initializeTagManager();
  }

  initializeTagManager = () => {
    const googleTagManagerId = CONFIG?.DATA?.ANALYTIC_GOOGLE_TAG_MANAGER_ID;
    if(googleTagManagerId){
      const tagManagerArgs = {
        gtmId: `${googleTagManagerId}`
      }
      TagManager.initialize(tagManagerArgs)
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // console.log(this.props.location.pathname , prevProps.location.pathname)
    if (this.props.location.pathname !== prevProps.location.pathname) {
      // console.log("activeState", this.state.activeItem)
      // $(".hiddenicon").css("display")
      if (this.state.activeItem) this.hidemenu();
    }
  }

  // setCSS() {
  //   let salt = new Date().getTime();

  //   if (CONFIG.DATA.THEME === 2) {
  //     var head = document.getElementsByTagName("HEAD")[0];
  //     var link = document.createElement("link");
  //     link.rel = "stylesheet";
  //     link.type = "text/css";
  //     link.href = "/assets/css/theme2.css?" + salt;
  //     head.appendChild(link);
  //   }

  //   if (CONFIG.DATA.BASIC_THEME === true) {
  //     var head = document.getElementsByTagName("HEAD")[0];
  //     var link = document.createElement("link");
  //     link.rel = "stylesheet";
  //     link.type = "text/css";
  //     link.href = "/assets/css/theme_basic.css?" + salt;
  //     head.appendChild(link);
  //   }

  //   if (CONFIG.DATA.ONLY_COUPONS === true) {
  //     var head = document.getElementsByTagName("HEAD")[0];
  //     var link = document.createElement("link");
  //     link.rel = "stylesheet";
  //     link.type = "text/css";
  //     link.href = "/assets/css/theme_coupons.css?" + salt;
  //     head.appendChild(link);
  //   }

  //   if (CONFIG.DATA.HAS_CUSTOM_CSS === true) {
  //     var head = document.getElementsByTagName("HEAD")[0];
  //     var link = document.createElement("link");
  //     link.rel = "stylesheet";
  //     link.type = "text/css";
  //     link.href = "/assets/sites/" + CONFIG.DATA.BACKEND_HOST + ".css?" + salt;
  //     head.appendChild(link);
  //   }

  //   if (CONFIG.DATA.BACKEND_HOST === 'dicksfreshmarket') {

  //     var link = document.createElement("meta");
  //     link.setAttribute("name", 'facebook-domain-verification');
  //     link.content = "hl6enm7e7nrs9s3i4r1oxj1esitcaa";
  //     document.getElementsByTagName('HEAD')[0].appendChild(link);

  //   }
  // }

  async setJS() {
    // for Universal Analytic + GA4 both
    if (
      CONFIG.DATA.ANALYTIC_GOOGLE_SITE_ID &&
      CONFIG.DATA.ANALYTIC_GOOGLE_SITE_ID !== "" &&
      CONFIG.DATA.ANALYTIC_GOOGLE_SITE_ID.length > 0
    ) {
      var head = document.getElementsByTagName("HEAD")[0];
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.src =
        "https://www.googletagmanager.com/gtag/js?id=" +
        CONFIG.DATA.ANALYTIC_GOOGLE_SITE_ID;
      script.async = true;
      head.appendChild(script);

      // NOT WORKING
      // var noscriptHtml = <noscript><iframe src="https://www.googletagmanager.com/ns.html?id={CONFIG.DATA.ANALYTIC_GOOGLE_SITE_ID}" height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
      // head.append(noscriptHtml);
      // document.getElementById("div-noscript").outerHTML = noscriptHtml
    }


    // for Facebook analytics only
    if (
      CONFIG.DATA.ANALYTIC_FB_PIXEL_ID &&
      CONFIG.DATA.ANALYTIC_FB_PIXEL_ID !== "" &&
      CONFIG.DATA.ANALYTIC_FB_PIXEL_ID.length > 0
    ) {
      var head = document.getElementsByTagName("HEAD")[0];
      // var script = document.createElement("script");
      // script.type = "text/javascript";
      // script.src =
      //   "https://www.googletagmanager.com/gtag/js?id=" +
      //   CONFIG.DATA.ANALYTIC_GOOGLE_SITE_ID;
      // script.async = true;
      // head.appendChild(script);

      // NOT WORKING
      var noscriptHtml = `<noscript><img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${CONFIG.DATA.ANALYTIC_FB_PIXEL_ID}&ev=PageView&noscript=1" /></noscript>`;
      var noscript = document.createElement("noscript");
      var iframe = document.createElement("img");
      iframe.setAttribute(
        "src",
        `https://www.facebook.com/tr?id=${CONFIG.DATA.ANALYTIC_FB_PIXEL_ID}&ev=PageView&noscript=1`
      );
      iframe.setAttribute("height", "1");
      iframe.setAttribute("width", "1");
      iframe.setAttribute("style", "display:none");
      noscript.appendChild(iframe);
      head.append(noscript);
    }

    // for sunshine
    if (
      CONFIG.DATA.CUSTOM_SCRIPT_URL &&
      CONFIG.DATA.CUSTOM_SCRIPT_URL !== "" &&
      CONFIG.DATA.CUSTOM_SCRIPT_URL.length > 0
    ) {
      var head = document.getElementsByTagName("HEAD")[0];
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.src = CONFIG.DATA.CUSTOM_SCRIPT_URL;
      script.async = true;
      head.appendChild(script);
    }

    if (CONFIG.DATA.HAS_CUSTOM_JAVASCRIPT) {
      var head = document.getElementsByTagName("HEAD")[0];
      script = document.createElement("script");
      script.type = "text/javascript";
      script.src = "/assets/sites/" + CONFIG.DATA.BACKEND_HOST + ".js";
      script.async = true;
      head.appendChild(script);

      /*
        NEED TO TRY IF THIS CODE WORKS
        var wrapper= document.createElement('div');
        wrapper.innerHTML= '<div><a href="#"></a><span></span></div>';
        var div= wrapper.firstChild;
      */
    }

    // var __html = require("assets/sites/" + CONFIG.DATA.BACKEND_HOST + ".jsx");
    // console.log(__html)
    // below code is not working
    // newly added dynamic script is not loading as expected
    if (CONFIG.DATA.HAS_CUSTOM_SCRIPT_TAG) {
      var head = document.getElementsByTagName("HEAD")[0];
      var wrapper = document.createElement("script");
      wrapper.type = "text/javascript";
      // console.log(1)
      let html = await this.fetchFile(
        "/assets/sites/" + CONFIG.DATA.BACKEND_HOST + ".script.js"
      );
      // console.log(4)
      wrapper.innerHTML = html;
      var htmlElement = wrapper.firstChild;
      htmlElement.addEventListener("load", function (e) {
        console.log("loaded..");
      });
      head.appendChild(wrapper);
    }

    //bakerfoodspw
    /* if (CONFIG.DATA.RSA_CLIENT_ID === 246 && CONFIG.DATA.BETA_SITE === true &&  CONFIG.DATA.BACKEND_HOST === 'bakerfoods') {
      
      var head = document.getElementsByTagName("HEAD")[0];
      script = document.createElement("script");
      script.type = "text/javascript";
      script.src = "/assets/sites/bakerfoodspw.js";
      script.async = true;
      head.appendChild(script);
    } */

    if (CONFIG.DATA.GEOFENCING_TRACKING_PIXEL_CODE && CONFIG.DATA.GEOFENCING_TRACKING_PIXEL_ADVERTISER_ID) {
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.src = "https://js.adsrvr.org/up_loader.1.1.0.js";
      script.async = true;
      
      script.onload = function() {
        const trackingScript = document.createElement('script');
        trackingScript.type = "text/javascript";
        trackingScript.innerHTML = `
          ttd_dom_ready(function() {
            if (typeof TTDUniversalPixelApi === 'function') {
              var universalPixelApi = new TTDUniversalPixelApi();
              universalPixelApi.init("${CONFIG.DATA.GEOFENCING_TRACKING_PIXEL_ADVERTISER_ID}", ["${CONFIG.DATA.GEOFENCING_TRACKING_PIXEL_CODE}"], "https://insight.adsrvr.org/track/up");
            }
          });
        `;
        document.body.appendChild(trackingScript);
      };
      
      script.onerror = function() {
        console.log("❌ Failed to load TTD script! 💀");
      };
      
      document.body.appendChild(script);
    }
  }

  async fetchFile(url) {
    // console.log(2)
    return await fetch(url).then((response) => {
      //  console.log(3);
      return response.text();
    });
  }

  Notification() {
    if (!ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`)) {
      this.setState({
        cartlist: 0,
      });
      return false;
    }

    const data = new FormData();
    var UserToken = ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`)
      ? ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`).UserToken
      : "";
    var apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/GetMyCartDetails/${UserToken}`;
    data.append("method", "POST");
    // data.append(
    //   "apiurl",
    //   `https://${CONFIG.DATA.RSA_SUBDOMAIN}.rsaamerica.com/Services/SSWebRestApi.svc/GetMyCartDetails/${UserToken}`
    // );

    if (UserToken) {
      var object = {};
      data.forEach((value, key) => (object[key] = value));
      var jsonData = JSON.stringify(object);

      axios
        .post(apiurl, jsonData, {
          headers: { domainname: CONFIG.DATA.RSA_SUBDOMAIN },
        })

        .then((res) => {
          this.setState({
            cartlist: res.data.MyCartInfo ? res.data.MyCartInfo.length : 0,
          });
        })
        .catch(function (response) {
          console.log(response);
        });
    }
  }

  Departments() {
    if (CONFIG.DATA.ONLY_COUPONS === true) return;

    const data = new FormData();
    var UserToken = ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`)
      ? ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`).UserToken
      : CONFIG.DATA.GUEST_TOKEN_USER;
    data.append("method", "POST");
    var apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/GetCategoriesForCoupons/${UserToken}`;
    // set user id
    // data.append(
    //   "apiurl",
    //   `https://${CONFIG.DATA.RSA_SUBDOMAIN}.rsaamerica.com/Services/SSWebRestApi.svc/GetCategoriesForCoupons/${UserToken}`
    // );
    var object = {};
    data.forEach((value, key) => (object[key] = value));
    var jsonData = JSON.stringify(object);

    axios
      .post(apiurl, jsonData, {
        headers: { domainname: CONFIG.DATA.RSA_SUBDOMAIN },
      })

      .then((res) => {
        if (res.data.GetProductCategories) {
          let department_list = res.data.GetProductCategories;
          department_list.sort((a, b) =>
            a.ProductCategoryName.localeCompare(b.ProductCategoryName)
          );
          ls.set("Departments", department_list);
          this.setState({ departments: res.data.GetProductCategories });
        } else {
          this.setState({ departments: [] });
        }
      })
      .catch(function (response) {
        console.log(response);
      });
  }

  Stores() {
    if (CONFIG.DATA.ONLY_COUPONS === true) return;

    const data = new FormData();
    data.append("method", "POST");

    var UserToken = ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`)
      ? ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`).UserToken
      : null;
    var apiurl;
    if (CONFIG.DATA.LOAD_STORE_FROM_DIFFERENT_URL) {
      // data.append(
      //   "apiurl",
      //   `https://${CONFIG.DATA.RSA_SUBDOMAIN}.rsaamerica.com/Services/SSWebRestApi.svc/GetclientStoresbyClientapp/${CONFIG.DATA.RSA_CLIENT_STORE_GROUP_ID}/''`
      // );
      apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/GetclientStoresbyClientapp/${CONFIG.DATA.RSA_CLIENT_STORE_GROUP_ID}/''`;
    } else {
      // NOTE: API IS SAME FOR LOGIN OR NON-LOGIN USERS
      if (UserToken)
        // data.append(
        //   "apiurl",
        //   `https://${CONFIG.DATA.RSA_SUBDOMAIN}.rsaamerica.com/Services/SSWebRestApi.svc/GetClientStores/1`
        // );
        apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/GetClientStores/1`;
      // data.append(
      //   "apiurl",
      //   `https://${CONFIG.DATA.RSA_SUBDOMAIN}.rsaamerica.com/Services/SSWebRestApi.svc/GetClientStores/1`
      // );
      else
        apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/GetClientStores/1`;
    }
    ls.remove("ClientStores");

    var object = {};
    data.forEach((value, key) => (object[key] = value));
    var jsonData = JSON.stringify(object);

    axios
      .post(apiurl, jsonData, {
        headers: { domainname: CONFIG.DATA.RSA_SUBDOMAIN },
      })

      .then((res) => {
        ls.set("ClientStores", res.data.GetClientStores);
        this.setState({ stores: res.data.GetClientStores });
      })
      .catch(function (response) {
        console.log(response);
      });
  }

  Alldata = () => {
    if (CONFIG.DATA.ONLY_COUPONS === true) return;

    ls.set("dataLoaded", false);
    const data = new FormData();
    data.append("method", "POST");
    // data.append(
    //   "apiurl",
    //   "https://grocery.rsaamerica.com/Services/SSWebRestApi.svc/GetCompanySettingsAndContactInfoByStoreGroup"
    // );
    var apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/GetCompanySettingsAndContactInfoByStoreGroup`;
    data.append("ClientAppName", CONFIG.DATA.RSA_CLIENT_APP_NAME);
    data.append("ClientId", CONFIG.DATA.RSA_CLIENT_ID);
    data.append("StoreGroupId", CONFIG.DATA.RSA_CLIENT_STORE_GROUP_ID);
    data.append("StoreId", CONFIG.DATA.RSA_CLIENT_STORE_ID);

    var object = {};
    data.forEach((value, key) => (object[key] = value));
    var jsonData = JSON.stringify(object);

    axios
      .post(apiurl, jsonData, {
        headers: { domainname: CONFIG.DATA.RSA_SUBDOMAIN },
      })
      .then((res) => {
        ls.set("dataLoaded", true);

        CONFIG.DATA.SUPPORT_EMAIL = res.data.CompanySettings.SupportEmail;
        CONFIG.DATA.SUPPORT_EMAIL_STORE = res.data.CompanySettings.StoreEmail;
        CONFIG.DATA.SUPPORT_PHONE = res.data.CompanySettings.StorePhoneNumber;
        CONFIG.DATA.SUPPORT_TIME = res.data.CompanySettings.StoreTimings;
        CONFIG.DATA.ABOUT_FOOTER = res.data.CompanySettings.WelcomeText;

        // 2020-02-27 - More sites now need it like there where only Web is allowed for link card not mobile..
        //      CONFIG.DATA.ALLOW_LINK_CARD_REGISTRATION = res.data.CompanySettings.AllowLinkCardRegistration;
        //      2019-10-21 force Panora to display link card on web (not on mobile app as flag is OFF from API)
        //      CONFIG.DATA.ALLOW_LINK_CARD_REGISTRATION = CONFIG.DATA.ALLOW_LINK_CARD_REGISTRATION || CONFIG.DATA.BACKEND_HOST === 'panora';
        CONFIG.DATA.ALLOW_LINK_CARD_REGISTRATION =
          CONFIG.DATA.ALLOW_LINK_CARD_REGISTRATION ||
          res.data.CompanySettings.AllowLinkCardRegistration;

        CONFIG.DATA.CONTACTUS_EMAIL =
          CONFIG.DATA.CONTACTUS_EMAIL || CONFIG.DATA.SUPPORT_EMAIL;
        CONFIG.DATA.EMPLOYMENT_EMAIL =
          CONFIG.DATA.EMPLOYMENT_EMAIL || CONFIG.DATA.SUPPORT_EMAIL;
        CONFIG.DATA.SUBSCRIPTION_EMAIL =
          CONFIG.DATA.SUBSCRIPTION_EMAIL || CONFIG.DATA.SUPPORT_EMAIL;

        CONFIG.DATA.socialmediasettings = res.data.SocialMediaSettings;

        if (this.props && this.props.location.search === "?debug=1") {
          console.log(this.props, CONFIG.DATA);
        }

        this.setState({ alldata: res.data });
        this.setState({ socialmediasettings: res.data.SocialMediaSettings });
      })
      .catch(function (response) {
        console.log(response);
      });
  };

  hidemenu = () => {
    this.setState({ activeItem: !this.state.activeItem });
  };

  triggerMouseLeave(e) {
    const mouseoverEvent = new Event("mouseleave");
    e.target.dispatchEvent(mouseoverEvent);
  }

  logout(e) {
    var redirectTo = ls.get("redirectTo");
    ls.remove(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`);
    ls.remove("ClientStores");
    ls.remove("Departments");
    ls.clear();
    this.showLogin();

    ls.set("redirectTo", redirectTo);
    window.location.reload();
  }

  showLogin(e) {
    if (CONFIG.DATA.SIGNIN_URL) {
      window.location.href = CONFIG.DATA.SIGNIN_URL;
      return false;
    }

    let redirectToPath = window.location.pathname;

    if (window.location.hash !== "")
      redirectToPath = redirectToPath + window.location.hash;

    if (this.props && this.props.location.search === "?debug=1") {
      console.log(window.location, window.location.hash, redirectToPath);
    }
    // ls.set('redirectTo', redirectToPath);
    this.props.history.push("/login");
    return false;
  }

  showRegister(e) {
    if (CONFIG.DATA.REGISTER_URL) {
      window.location.href = CONFIG.DATA.REGISTER_URL;
      return false;
    }

    let redirectToPath = window.location.pathname;

    if (window.location.hash !== "")
      redirectToPath = redirectToPath + window.location.hash;

    if (this.props && this.props.location.search === "?debug=1") {
      console.log(window.location, window.location.hash, redirectToPath);
    }
    // ls.set('redirectTo', redirectToPath);
    this.props.history.push(
      CONFIG.DATA.ALLOW_LINK_CARD_REGISTRATION
        ? "/register"
        : "/simple-register"
    );
    return false;
  }

  render() {
    //var IsLoggedIn = ls.get('userdata') ? true : false;

    let socialicons = this.state.socialmediasettings;
    let departments = this.state.departments;
    let stores = this.state.stores;

    let AppsAvailable =
      CONFIG.DATA.APP_URL_ANDROID !== "" || CONFIG.DATA.APP_URL_IOS !== "";

    let SocialMediaAvailable = socialicons
      ? socialicons.find(
          (val) => val.IsSocialMedia === true && val.Value !== ""
        )
      : false;
    // console.log(SocialMediaAvailable);

    // hide social media icons at top, in basic theme..
    if (CONFIG.DATA.BASIC_THEME === true) {
      SocialMediaAvailable = false;
      socialicons = null;
    }

    if (socialicons) {
      socialicons.sort(function (a, b) {
        return a.SequenceNumber - b.SequenceNumber;
      });
    }

    const socialicon = socialicons
      ? socialicons.map((val, index) => {
          if (val.IsSocialMedia === true && val.Value !== "") {
            return (
              <span key={index}>
                <a
                  href={val.Value}
                  className="mr-1"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    loading="lazy"
                    alt={val.Title}
                    title={val.Title}
                    src={val.ImageURL}
                    style={{ height: "25px" }}
                  />
                </a>
              </span>
            );
          }
        })
      : null;

    /* New Department menu coming from cmd Added By Alok 005-06-2021  */
    if (departments) {
      var menu_dept = CONFIG.DATA.MENU.find(
        (x) => x.menu_url === "/department"
      );

      if (menu_dept) {
        var submenu_dept = [];

        var dept_info = CONFIG.DATA.DEPARTMENTS || [];

        if (dept_info.length > 0) {
          dept_info.map((value, index) => {
            if (
              value.ProductCategoryId !== 10001 &&
              value.ProductCategoryId !== 10002
            ) {
              submenu_dept.push({
                submenu_index: index,
                submenu_name: value.departmentname,
                submenu_url:
                  "/department/" +
                  value.slug
                    .replace(/\s/g, "-")
                    .replace(/\//g, "_")
                    .toLowerCase(),
                submenu_visible: true,
                submenu_link: false,
                submenu_type: 1,
              });
            }
          });
        } else {
          var submenu_dept = [];

          departments.map((value, index) => {
            if (
              value.ProductCategoryId !== 10001 &&
              value.ProductCategoryId !== 10002
            ) {
              submenu_dept.push({
                submenu_index: index,
                submenu_name: value.ProductCategoryName,
                submenu_url:
                  "/department/" +
                  value.ProductCategoryName.replace(/\s/g, "-")
                    .replace(/\//g, "_")
                    .toLowerCase(),
                submenu_visible: true,
                submenu_link: false,
                submenu_type: 1,
              });
            }
          });
        }
        menu_dept.submenu = submenu_dept;
      }
    }

    if (stores) {
      var menu_store = CONFIG.DATA.MENU.find(
        (x) => x.menu_url === "/weekly-ads"
      );
      // HR:2021-06-02
      // hide gallery view for all, as most of clients are requesting to have full screen Ads visibility.
      var link = "weekly-ads"; // CONFIG.DATA.THEME == 2 && CONFIG.DATA.WEEKLY_AD_FULL_SCREEN === false ? "weekly-ads-gallery" : "weekly-ads";
      var submenu_store = [];
      stores.map((value, index) => {
        // console.log(value)
        submenu_store.push({
          submenu_index: index,
          submenu_name: value.ClientStoreName,
          submenu_url:
            "/" +
            link +
            "/" +
            value.ClientStoreId +
            "/" +
            value.ClientStoreName.replace(/\s/g, "-")
              .replace(/\//g, "_")
              .toLowerCase(),
          submenu_visible: true,
          submenu_link: false,
          submenu_type: 1,
        });
      });

      if (menu_store) {
        menu_store.submenu = submenu_store;
      }
    }

    var activeItem = this.state.activeItem;

    var userdata = ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`);

    return (
      <div>
        {CONFIG.DATA.THEME === 1 ? (
          <div className="site-wrap mb-4">
            <div className="site-mobile-menu site-navbar-target">
              <div className="site-mobile-menu-header">
                <div className="site-mobile-menu-close mt-3">
                  <span
                    onClick={this.hidemenu}
                    className="icon-close2 js-menu-toggle"
                  ></span>
                </div>
              </div>
              <div className="site-mobile-menu-body"></div>
            </div>
            <div className="py-2">
              <div className="container">
                <div className="row align-items-center top-manu-border">
                  <div className="col-lg-3">
                    {CONFIG.DATA.HEADER_SUBTITLE &&
                    CONFIG.DATA.HEADER_SUBTITLE !== "" ? (
                      <div style={{ textAlign: "left", color: "#000" }}>
                        {CONFIG.DATA.HEADER_SUBTITLE}
                      </div>
                    ) : (
                      ""
                    )}

                    <div>
                      <ul style={{ listStyleType: "none", float: "left" }}>
                        <li className="hidden-xs-up hidden-md-up hidden-lg-up">
                          <span onClick={this.hidemenu} className="hiddenicon">
                            <i className="fa fa-bars"></i>
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>

                  {/*<div className="col-lg-3"></div>*/}
                  <div
                    className="col-lg-3 d-block text-right social-icons"
                    style={{ zIndex: 101 }}
                  >
                    {SocialMediaAvailable ? (
                      <span to="#" className="mr-3 font-color-4c4c4c">
                        Follow Us :{" "}
                      </span>
                    ) : (
                      ""
                    )}
                    {SocialMediaAvailable ? socialicon : ""}
                  </div>

                  <div
                    className="col-lg-3 d-block d-lg-block text-right"
                    style={{ zIndex: 101, padding: "4px" }}
                  >
                    {AppsAvailable ? (
                      <span
                        to="#"
                        className="mr-3 font-color-4c4c4c"
                        style={{ color: "#000" }}
                      >
                        Download Our App :{" "}
                      </span>
                    ) : (
                      ""
                    )}

                    {}

                    {CONFIG.DATA.RSA_SUBDOMAIN === "raysapplemarket" ? (
                      <a
                        href={`https://raysapplemarket.rsapwaapp.com/`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="mr-1"
                      >
                        <img
                          loading="lazy"
                          alt="Download from Google Play"
                          title="Download from Google Play"
                          src="/assets/images/PWA_small_logo.jpg"
                          style={{ width: "42px", height: "41px" }}
                        />
                      </a>
                    ) : CONFIG.DATA.APP_URL_ANDROID !== "" ? (
                      <a
                        href={CONFIG.DATA.APP_URL_ANDROID}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="mr-1"
                      >
                        <img
                          loading="lazy"
                          alt="Download from Google Play"
                          title="Download from Google Play"
                          src="/assets/images/icons/google-play-300x300.png"
                          style={{ width: "25px" }}
                        />
                      </a>
                    ) : (
                      ""
                    )}

                    {CONFIG.DATA.RSA_SUBDOMAIN === "raysapplemarket" ||
                    CONFIG.DATA.RSA_SUBDOMAIN === "raysapplemarket" ? (
                      ""
                    ) : CONFIG.DATA.APP_URL_IOS !== "" ? (
                      <a
                        href={CONFIG.DATA.APP_URL_IOS}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="mr-3"
                      >
                        <img
                          loading="lazy"
                          alt="Download from App Store"
                          title="Download from App Store"
                          src="/assets/images/icons/appstore-2-300x300.jpg"
                          style={{ width: "25px" }}
                        />
                      </a>
                    ) : (
                      ""
                    )}
                  </div>

                  {userdata ? (
                    <div
                      className={
                        CONFIG.DATA.THEME == 2
                          ? "col-lg-3 site-navbar site-navbar1 theme_2_menu"
                          : "col-lg-3 site-navbar site-navbar1"
                      }
                      style={{
                        display: "inline-block",
                        width: "100%",
                        float: "right",
                      }}
                    >
                      <nav
                        style={{}}
                        className="site-navigation position-relative text-right userloginmenu"
                        role="navigation"
                      >
                        <ul className="site-menu main-menu js-clone-nav mr-auto   d-lg-block font-weight-c">
                          <li className="has-children">
                            <Link
                              to="#"
                              className="nav-link text-left username"
                              style={{ color: "#fff" }}
                            >
                              {userdata.LastName + " " + userdata.FirstName}
                            </Link>
                            <ul className="dropdown" style={{ zIndex: 111 }}>
                              <li className="bg-white">
                                <Link to="/my-account">My Account</Link>
                              </li>
                              {CONFIG.DATA.ALLOW_PASSWORD ||
                              CONFIG.DATA.RSA_SUBDOMAIN === "superiorgrocers" ||
                              CONFIG.DATA.RSA_SUBDOMAIN ===
                                "sandssupermarket" ||
                              CONFIG.DATA.RSA_SUBDOMAIN === "bakerfoodspw" ? (
                                <li className="bg-white">
                                  <Link to="/change-pin">Change Password</Link>
                                </li>
                              ) : (
                                <li className="bg-white">
                                  <Link to="/change-pin">Change Pin</Link>
                                </li>
                              )}

                              <li className="bg-white">
                                <Link to="/my-rewards">My Rewards</Link>
                              </li>
                              <li className="bg-white">
                                <Link
                                  to="#"
                                  onClick={(event) => {
                                    this.logout(event);
                                  }}
                                >
                                  Logout
                                </Link>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  ) : (
                    ""
                  )}
                  {userdata ? (
                    ""
                  ) : (
                    <div className="col-lg-3 text-right ">
                      <Link
                        to="#"
                        title="Sign In"
                        onClick={(e) => {
                          this.showLogin(e);
                        }}
                        className="mr-3 font-color-4c4c4c text-uppercase"
                      >
                        Login
                      </Link>
                      <Link
                        to="#"
                        title="Register"
                        onClick={(e) => {
                          this.showRegister(e);
                        }}
                        className="px-4 py-2 rounded-0 font-color-4c4c4c text-uppercase"
                      >
                        {CONFIG.DATA.REGISTER_LABEL
                          ? CONFIG.DATA.REGISTER_LABEL
                          : "Register"}
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <HeaderNav
              cartlist={this.state.cartlist}
              activeItem={activeItem}
              userdata={userdata}
            />
          </div>
        ) : (
          <div
            className="apus-topbar site-wrap mb-4 "
            style={{
              background:
                CONFIG.DATA.RSA_SUBDOMAIN === "superiorgrocers"
                  ? "#EB2B26"
                  : CONFIG.DATA.HEADER_BG_COLOR,
            }}
          >
            <div className="site-mobile-menu site-navbar-target">
              <div className="site-mobile-menu-header">
                <div className="site-mobile-menu-close mt-3">
                  <span
                    onClick={this.hidemenu}
                    className="icon-close2 js-menu-toggle"
                  ></span>
                </div>
              </div>
              <div className="site-mobile-menu-body"></div>
            </div>
            <div className={"pb-0 mb-1"}>
              <div className="container">
                <div className="row align-items-center top-manu-border">
                  <div className="col-lg-5" style={{ textAlign: "left" }}>
                    <div>
                      <ul
                        style={{
                          listStyleType: "none",
                          float: "left",
                          paddingLeft: "0px",
                          paddingRight: "10px",
                        }}
                      >
                        <li className="hidden-xs-up hidden-md-up hidden-lg-up">
                          <span onClick={this.hidemenu} className="hiddenicon">
                            <i className="fa fa-bars"></i>
                          </span>
                        </li>
                      </ul>
                    </div>

                    <div>
                      <div className="slogan1">
                        <aside className="widget widget_text">
                          <div className="textwidget">
                            <p
                              style={{ marginBottom: "0px" }}
                              dangerouslySetInnerHTML={{
                                __html: CONFIG.DATA.HEADER_SUBTITLE
                                  ? CONFIG.DATA.HEADER_SUBTITLE
                                  : "",
                              }}
                            ></p>
                          </div>
                        </aside>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-1"></div>

                  <div className="col-lg-6">
                    <div className="pull-right">
                      <div
                        className={
                          (userdata ? "" : "") +
                          " d-none d-lg-block social-icons"
                        }
                        style={{ zIndex: 101 }}
                      >
                        <aside className="widget widget_apus_socials_widget">
                          <ul className="social list-unstyled  bo-sicolor pull-right">
                            {
                              // (socialicon)
                              socialicons &&
                                socialicons.map((val, index) => {
                                  if (
                                    val.IsSocialMedia === true &&
                                    val.Value !== ""
                                  ) {
                                    return (
                                      <li key={index}>
                                        <a
                                          href={val.Value}
                                          title={val.Title}
                                          className={val.Title.toLowerCase()}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          <i
                                            className={
                                              "fa fa-" +
                                              val.Title.toLowerCase() +
                                              " bo-social-" +
                                              val.Title.toLowerCase() +
                                              ""
                                            }
                                          >
                                            &nbsp;
                                          </i>
                                          <span className="hidden">
                                            {val.Title}
                                          </span>
                                        </a>
                                      </li>
                                    );
                                  }
                                })
                            }
                          </ul>
                        </aside>
                      </div>
                    </div>
                    <div className="pull-right">
                      {userdata ? (
                        <div
                          className={
                            CONFIG.DATA.THEME == 2
                              ? " site-navbar site-navbar1 theme_2_menu_profile"
                              : " site-navbar site-navbar1"
                          }
                        >
                          <nav
                            style={{}}
                            className="site-navigation position-relative text-right userloginmenu"
                            role="navigation"
                          >
                            <ul className="site-menu main-menu js-clone-nav mr-auto d-lg-block font-weight-t">
                              <li className="has-children">
                                {CONFIG.DATA.BACKEND_HOST === "prengerfoods" ? (
                                  <Link
                                    to="#"
                                    className="nav-link text-left username"
                                    style={{
                                      color: "#000",
                                      textTransform: "capitalize",
                                      fontWeight: "normal",
                                      fontSize: "15px",
                                    }}
                                  >
                                    Welcome,{" "}
                                    {userdata.LastName +
                                      " " +
                                      userdata.FirstName}
                                  </Link>
                                ) : (
                                  <Link
                                    to="#"
                                    className="nav-link text-left username"
                                    style={{
                                      color: "#fff",
                                      textTransform: "capitalize",
                                      fontWeight: "normal",
                                      fontSize: "15px",
                                    }}
                                  >
                                    Welcome,{" "}
                                    {userdata.LastName +
                                      " " +
                                      userdata.FirstName}
                                  </Link>
                                )}
                                <ul
                                  className="dropdown"
                                  style={{ zIndex: 111 }}
                                >
                                  <li className="bg-white">
                                    <Link to="/my-account">My Account</Link>
                                  </li>
                                  {CONFIG.DATA.ALLOW_PASSWORD ||
                                  CONFIG.DATA.RSA_SUBDOMAIN ===
                                    "superiorgrocers" ||
                                  CONFIG.DATA.RSA_SUBDOMAIN ===
                                    "sandssupermarket" ||
                                  CONFIG.DATA.RSA_SUBDOMAIN ===
                                    "bakerfoodspw" ? (
                                    <li className="bg-white">
                                      <Link to="/change-pin">
                                        Change Password
                                      </Link>
                                    </li>
                                  ) : (
                                    <li className="bg-white">
                                      <Link to="/change-pin">Change PIN</Link>
                                    </li>
                                  )}
                                  <li className="bg-white">
                                    <Link to="/my-rewards">My Rewards</Link>
                                  </li>
                                  <li className="bg-white">
                                    <Link
                                      to="#"
                                      onClick={(event) => {
                                        this.logout(event);
                                      }}
                                    >
                                      Logout
                                    </Link>
                                  </li>
                                </ul>
                              </li>
                            </ul>
                          </nav>
                        </div>
                      ) : (
                        <div className=" text-right mt-1 sign-in-register">
                          <Link
                            to="#"
                            title="Sign In"
                            onClick={(e) => {
                              this.showLogin(e);
                            }}
                            className={
                              `mr-3  font-color-4c4c4c ` +
                              (CONFIG.DATA.BACKEND_HOST === "lewisfood" ||
                              CONFIG.DATA.BACKEND_HOST === "haysmarketcoupons"
                                ? `font-weight-bold`
                                : ``)
                            }
                            style={{ textTransform: "uppercase" }}
                          >
                            Login
                          </Link>
                          <Link
                            to="#"
                            title="Register"
                            onClick={(e) => {
                              this.showRegister(e);
                            }}
                            className={
                              `px-4 py-2 rounded-0 font-color-4c4c4c no-right-pad ` +
                              (CONFIG.DATA.BACKEND_HOST === "lewisfood" ||
                              CONFIG.DATA.BACKEND_HOST === "haysmarketcoupons"
                                ? `font-weight-bold`
                                : ``)
                            }
                            style={{ textTransform: "uppercase" }}
                          >
                            Register
                          </Link>
                          {CONFIG.DATA.FACEBOOK_URL !== "" && (
                            <a
                              href={CONFIG.DATA.FACEBOOK_URL}
                              title="Facebook"
                              target="_blank"
                              style={{ marginLeft: "2rem" }}
                              rel="noopener noreferrer"
                            >
                              <img
                                src="/assets/images/facebook.png"
                                style={{ height: "1.8rem" }}
                                alt="facebook"
                              />
                            </a>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <HeaderNav
              cartlist={this.state.cartlist}
              activeItem={activeItem}
              userdata={userdata}
            />
          </div>
        )}
      </div>
    );
  }
}
export default withRouter(Header);
